export default "__VITE_ASSET__Cv2uaC9P__"